export interface WhatsNewItem {
    id: string;
    title: string;
    description: string;
    date: string;
    imageUrl?: string; // Optional
}

export interface NewVersionNotificationProps {
    title?: string;
    message?: string;
    whatsNew: WhatsNewItem[];
    onDismiss: () => void;
}
